var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.747,
    height: 24.747,
    viewBox: "0 0 24.747 24.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scheduled",
    transform: "translate(0 -0.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scheduled-icon-grey",
    transform: "translate(0 0.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M7.4,5.77V4.437H17.35V5.771h2.057V4.437h1.642a1.643,1.643,0,0,1,1.64,1.641V8.441H2.057V6.078A1.644,1.644,0,0,1,3.7,4.435H5.34V5.77ZM22.689,10.5V21.426a1.643,1.643,0,0,1-1.64,1.641H3.7a1.643,1.643,0,0,1-1.642-1.641V10.5ZM21.049,2.38H19.407v-2H17.35v2H7.4v-2H5.339v2H3.7A3.7,3.7,0,0,0,0,6.078v15.35a3.7,3.7,0,0,0,3.7,3.7h17.35a3.7,3.7,0,0,0,3.7-3.7V6.076A3.7,3.7,0,0,0,21.049,2.38Z",
    transform: "translate(0 -0.378)",
    fill: "#404149",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduled);
export default __webpack_public_path__ + "static/media/Scheduled.fc1e588fd0fbb3a30bd4d9a1f85b34a6.svg";
export { ForwardRef as ReactComponent };